import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Image,
  Input,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useContext } from "react";
import { FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AuthContext/AuthContext";
import DrawerCart from "./cartDrower";
import CatagoryPop from "./Catagorypop";
import DrawerLogin from "./logindrowr";
import PopingComp from "./PopingComp";

const SideBar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const navigate = useNavigate();
  const { isAuth, setQueerydata } = useContext(AppContext);

  const handleHomeNav = () => {
    navigate("/");
  };

  const handleChange = (e) => {
    navigate("/our-foods");
    setQueerydata(e.target.value);
  };

  return (
    <Box display="flex">
      <Button
        borderRadius={"0px"}
        ref={btnRef}
        colorScheme={"whiteAlpha"}
        color={"black"}
        onClick={onOpen}
      >
        <FaBars />
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size={"xs"}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader cursor={"pointer"} onClick={handleHomeNav}>
            Home
          </DrawerHeader>

          <DrawerBody>
            <Stack>
              <Box>
                <Input
                  placeholder="Search Your Delicious Food"
                  size="md"
                  htmlSize={40}
                  disabled={isAuth}
                  onChange={handleChange}
                />
              </Box>
              <DrawerLogin />
              <DrawerCart />
              <PopingComp />
            </Stack>
          </DrawerBody>

          <DrawerFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Back
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default SideBar;
